/* eslint-disable max-len */
/* eslint-disable max-lines */
/* eslint-disable max-statements */
import {useEffect, useState} from 'react';
import moment from 'moment';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {validateDates} from '../../../utils';
import {useDispatch, useSelector} from 'react-redux';
import {Actions} from '../../../../common/actions';
import {mapListToDropdownList} from '../../../../floatingInventory/utils/commonUtils';
import {noTimeZoneTinyISODate} from '../../../../common/constants/datesFormat';
import {pricesActions} from '../../../constants';
import {getAllMonthsInRange, getNextDate, removeRangeFromDatesList} from '../../../helpers/pricesUtils';

const {
  addMessageBoxError,
  createPriceColor,
  clearActiveColorPrices,
  editPriceColor,
  fetchActivePriceColor,
  fetchEmptyPriceColor,
  updateColorPrice,
} = Actions;

export const useModelInfo = ({
  selectedVehicle,
  openHistoryPriceModal,
  updateDateMode,
  setUpdateMode,
  activeColorsList,
  selectedProduction,
  setSelectedProduction,
  setActiveColorsListCurr,
  activeColorsListDB,
}) => {
  const {masterCode, description, sfx} = selectedVehicle;
  const dispatch = useDispatch();
  const permissions = useSelector((state) => state.session.permissions);
  const activeProductions = useSelector((state) => state.vehiclePriceColor.activeProductions);
  const activeColorsEmpty = useSelector((state) => state.vehiclePriceColor.activeColorsEmpty);
  const loadingSave = useSelector((state) => state.vehiclePriceColor.loadingSave);
  const [notAllowedDates, setNotAllowedDates] = useState([]);
  const [activeProductionsList, setActiveProductionsList] = useState([]);
  const [maxDate, setMaxDate] = useState(null);

  const [datesInfo, setDatesInfo] = useState({
    'masterCode': null,
    'sfx': null,
    'newStartDate': null,
    'newEndDate': null,
    'prevStartDate': null,
    'prevEndDate': null,
    'groupId': null,
  });

  const onChangeField = (key, value) => {
    setDatesInfo((old) => ({
      ...old,
      [key]: value,
    }));
  };
  
  const onSave = (processedData) => {
    if (!hasAccessPermission(permissions, resources.VehiclesHistoryColor, scopes.Create)) {
      dispatch(addMessageBoxError('Petición no procesada, no tiene permisos para realizar esta acción.'));
      return;
    }
    if (updateDateMode === pricesActions.addProduction) {
      const validObj = validateDates(datesInfo.newStartDate, datesInfo.newEndDate);
      if (validObj.isValid) {
        dispatch(createPriceColor(processedData, setUpdateMode));
      } else {
        dispatch(addMessageBoxError(validObj.message));
      }
    }
    if (updateDateMode === pricesActions.editDate) {
      const validObj = validateDates(datesInfo.prevStartDate, datesInfo.prevEndDate);
      if (validObj.isValid) {
        dispatch(editPriceColor(processedData, setUpdateMode));
      } else {
        dispatch(addMessageBoxError(validObj.message));
      }
    }
    if (updateDateMode === pricesActions.editPrices) {
      dispatch(updateColorPrice(processedData, setUpdateMode));
    }
  };

  const handleSave = () => {
    const processedData = {
      'header': {
        ...datesInfo,
        'startDate': updateDateMode === pricesActions.addProduction ? datesInfo.newStartDate : datesInfo.prevStartDate,
        'endDate': updateDateMode === pricesActions.addProduction ? datesInfo.newEndDate : datesInfo.prevEndDate,
        'prevStartDate': selectedProduction,
      },
      'data': activeColorsList,
    };
    onSave(processedData);
  };

  const handleChangeProduction = (value) => {
    dispatch(clearActiveColorPrices());
    setActiveColorsListCurr([]);
    setSelectedProduction(value);
  };

  const handleAddProduction = () => {
    dispatch(fetchEmptyPriceColor(masterCode, sfx));
    setUpdateMode(pricesActions.addProduction);
  };

  const handleCancel = () => {
    setUpdateMode(pricesActions.read);
    if (activeProductions.length) {
      const startDate = activeProductions[0].startDate;
      let formattedDate = '';
      if (startDate) {
        const [month, year] = startDate.split('/');
        formattedDate = `${year}-${month}`;
      }
      const data = {
        'masterCode': masterCode,
        'sfx': sfx,
        'startDate': formattedDate,
      };
      setSelectedProduction(startDate || null);
      dispatch(fetchActivePriceColor(data));
    }
  };

  useEffect(() => {
    if (activeProductions.length) {
      setActiveProductionsList(mapListToDropdownList(
        activeProductions,
        {
          'keys': ['startDate'],
          'values': ['startDate'],
          'texts': ['startDate', 'endDate'],
        }
      ));
      setNotAllowedDates(getAllMonthsInRange(activeProductions));
    } else {
      setActiveProductionsList([]);
      setNotAllowedDates([]);
      setSelectedProduction(null);
    }
  }, [activeProductions]);

  useEffect(() => {
    if (updateDateMode === pricesActions.read) {
      setNotAllowedDates(getAllMonthsInRange(activeProductions));
    }
    if (updateDateMode === pricesActions.editDate) {
      const modNotAllowedDates = removeRangeFromDatesList(
        selectedProduction,
        activeProductions,
        getAllMonthsInRange(activeProductions)
      );
      setNotAllowedDates(modNotAllowedDates);
      datesInfo.prevStartDate && setMaxDate(getNextDate(datesInfo.prevStartDate, modNotAllowedDates));
    }
    if (updateDateMode === pricesActions.addProduction) {
      datesInfo.newStartDate && setMaxDate(getNextDate(datesInfo.newStartDate, notAllowedDates));
    }
  }, [updateDateMode]);
  
  useEffect(() => {
    if (activeColorsListDB.length) {
      const {groupId, startDate, endDate} = activeColorsListDB[0];
      setDatesInfo({
        'masterCode': masterCode,
        'description': description,
        'sfx': sfx,
        'newStartDate': endDate && moment(endDate).add(1, 'month').format(noTimeZoneTinyISODate),
        'newEndDate': null,
        'prevStartDate': startDate && moment(startDate).format(noTimeZoneTinyISODate),
        'prevEndDate': endDate && moment(endDate).format(noTimeZoneTinyISODate),
        'groupId': (groupId || 0) + 1,
      });
    }
  }, [activeColorsListDB]);

  useEffect(() => {
    if (activeColorsEmpty.length) {
      const {groupId, startDate, endDate} = activeColorsListDB.length ? activeColorsListDB[0] : {};
      setDatesInfo({
        'masterCode': masterCode,
        'description': description,
        'sfx': sfx,
        'newStartDate': endDate && moment(endDate).add(1, 'month').format(noTimeZoneTinyISODate),
        'newEndDate': null,
        'prevStartDate': startDate && moment(startDate).format(noTimeZoneTinyISODate),
        'prevEndDate': endDate && moment(endDate).format(noTimeZoneTinyISODate),
        'groupId': (groupId || 0) + 1,
      });
    }
  }, [activeColorsEmpty]);

  useEffect(() => {
    setDatesInfo({
      ...datesInfo,
      'newEndDate': datesInfo.newStartDate,
    });
    datesInfo.newStartDate && setMaxDate(getNextDate(datesInfo.newStartDate, notAllowedDates));
  }, [datesInfo.newStartDate]);

  useEffect(() => {
    setDatesInfo({
      ...datesInfo,
      'prevEndDate': datesInfo.prevStartDate,
    });
    
    datesInfo.prevStartDate && setMaxDate(getNextDate(datesInfo.prevStartDate, notAllowedDates));
  }, [datesInfo.prevStartDate]);

  return {
    'actions': {
      onChangeField,
      handleSave,
      handleAddProduction,
      handleCancel,
      openHistoryPriceModal,
      clearActiveColorPrices,
      handleChangeProduction,
    },
    'data': {
      activeProductions,
      datesInfo,
      activeProductionsList,
      notAllowedDates,
      maxDate,
      loadingSave,
    },
  };
};
